import { useEffect, useState } from "react";


export const WarningButton = (props: any) => {
    const {data, isVisibleWarning2Button} = props;
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const checkVisible = async () => {
            const visible = await isVisibleWarning2Button(data);
            setIsVisible(visible);
        }
        checkVisible();
    },[data, isVisibleWarning2Button])

    return isVisible ? <span className="dx-icon dx-icon-attach" role="button" style={{padding: 0, fontSize: '18px'}} title="Nội dung tài liệu được đính kèm đã bị thay đổi. Vui lòng kiểm tra lại"/> : null
}